// extracted by mini-css-extract-plugin
export default {"root":"dots_root__TYBVS","dotsLoader":"dots_dotsLoader__y3UE6","dot":"dots_dot__kwRy5","dotsLoaderPulse":"dots_dotsLoaderPulse__Y2r5u"};